import { request, requestFull } from "./request.js";

export async function current() {
    return await requestFull("/checkup/current", { }, "POST");
}

export async function close(data) {
    return await request("/appointment/close", data, "POST");
}

export async function save(data) {
    return await request("/checkup/save", data, "POST");
}
